export const isLogged = () => !!localStorage.getItem('privateKey')
